import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
function MultiFilterSelect(props) {
  function filterOptions(options, input) {
    const regex = new RegExp(`(?=.*${input.trim().split(/\s+/).join(')(?=.*')})`, 'gi');
    return options.filter(option => regex.test(option.text));
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-test-id": "filter-select-label",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: props.labelLangPath
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      "data-test-id": "filter-select-internal",
      defaultValue: props.defaultValue,
      filterOptions: filterOptions,
      menuRenderer: virtualizedMenuRenderer,
      multi: true,
      multiCollapseLimit: 1,
      onChange: ({
        target: {
          value
        }
      }) => props.onSelect(value),
      options: props.options,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.placeholderLangPath
      })
    })
  });
}
MultiFilterSelect.propTypes = {
  defaultValue: PropTypes.array,
  labelLangPath: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholderLangPath: PropTypes.string.isRequired
};
MultiFilterSelect.defaultProps = {
  defaultValue: []
};
export default /*#__PURE__*/memo(MultiFilterSelect);